import React, { useEffect, useState } from "react";
import { Tooltip, IconButton, Grid } from "@material-ui/core";
import { CommonStyles } from "../../../commons/CommonStyles";
import { checkIsNullUndefined, getErrorMessage } from "../../../commons/Utils";
import { useTranslation } from "react-i18next";
import { BasicDialog } from "../../CommonComponents/BasicDialog";
import DeleteIcon from "@material-ui/icons/Delete";
import { DeleteSystemUserDeleteByEnterprise, DeleteSystemUserDeleteByUser } from "../../../services/ReasonService";
import { CorreosIcon } from "../../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../../commons/EnumsGeneral";

export function DialogSystemUserDelete(props) {
  const commonClasses = CommonStyles();
  const { t, i18n } = useTranslation();
  const { clientId, idEnterprise, refresh, finishOperation } = props;

  const [open, setOpen] = useState(false);


  useEffect(() => { }, []);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    let auxCall = checkIsNullUndefined(idEnterprise) ? DeleteSystemUserDeleteByUser : DeleteSystemUserDeleteByEnterprise;
    auxCall(clientId, idEnterprise).then((response) => {
      if (response && !response.Status) {
        finishOperation("success", t("systemUserPageDeleteSuccess"));
        refresh();
      } else {
        finishOperation("error", getErrorMessage(response, t));
      };
      handleCancel();
    });
  };

  return (
    <>
      <BasicDialog
        open={open}
        setOpen={setOpen}
        title={t("systemUserPageDeleteTitle")}
        text={t("systemUserPageDeleteText").replace("{client_id}", clientId)}
        action={() => { handleDelete() }}
        closeAction={() => { handleCancel() }}
      />
      <Grid item xs={12} >
        <Tooltip title={t("delete")}>
          <IconButton
            style={{ padding: "0.1em" }}
            onClick={() => setOpen(true)}
          >
            <CorreosIcon iconSelected={iconNames.delete} iconName="Delete Icon" iconState="enabled" iconScale={1.5} />
            {/* <DeleteIcon
              className={commonClasses.iconActionStyle}
            /> */}
          </IconButton>
        </Tooltip>
      </Grid>
    </>
  );
}
